export default __webpack_public_path__ + "images/4533b3a17e2846dc84c5f4e6aa966060-amex.svg";